import React from 'react';
import isEqual from 'is-equal';
import { useNavigate, useParams } from 'react-router-dom';
import { Image } from 'react-bootstrap';

import AuthService from 'src/utils/auth.service';
import styles from './style.module.scss';
import { localizedStrings } from 'src/localization/index';

const LoadingIcon = '/images/loading_plane.gif';

class MicrosoftWopiIntegrationProcessingView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};

    this.localizedAsset = localizedStrings.pages.asset;
    this.localizedAssetDetail = this.localizedAsset.asset_detail_view;
  }

  componentDidMount() {
    const assetId = this.props.params?.assetId || this.props.params?.id;
    if (assetId) {
      this.props.updateNewVersionAsset(assetId);
    } else {
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.processed, nextProps.processed)) {
      if (nextProps.processed) {
        if (nextProps.asset && nextProps.asset.id) {
          const path = `/assets/${nextProps.asset.id}`;
          this.props.navigate(path, { replace: true });
        } else {
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.invalidateWopiIntegration();
  }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.container}>
          <div className={styles.dialog}>
            {this._renderValidationMessage()}
          </div>
        </div>
      </div>
    );
  }

  _renderValidationMessage() {
    return (
      <div className={styles.loading}>
        <Image src={LoadingIcon} />
        <h4 className={styles.title}>{this.localizedAssetDetail.processing}....</h4>
        <div className={styles.message}>{this.localizedAssetDetail.refresh}</div>
      </div>
    );
  }
}
const MicrosoftWopiIntegrationProcessingViewWrapper = (props) => {
  const navigate = useNavigate();
  const params = useParams();  
  return (
    <MicrosoftWopiIntegrationProcessingView 
      {...props} 
      navigate={navigate}
      params={params}
    />
  );
};

export default MicrosoftWopiIntegrationProcessingViewWrapper;